import { useRouter } from 'next/router';
import { useCompletionHistoryCustomFilters, useReduxState } from 'hooks';
import { FlexContainer, Search } from 'components/common';
import { DateRangeSelector } from 'components/common/charts';
import { Filters, FiltersActive } from 'components/common/filter';

const ProfileCompletionsSubheaderFilters = () => {
  const { messages } = useReduxState();

  const router = useRouter();

  const handleDateRangeChange = ({ fromDate, toDate }) => {
    if (fromDate && toDate) {
      router.replace({ query: { ...router.query, fromDate, toDate } });
    } else {
      const queryParams = router.query || {};
      delete queryParams.fromDate;
      delete queryParams.toDate;

      router.replace({ query: queryParams });
    }
  };

  const handleSearch = ({ search }: { search: string }) => {
    if (search) {
      router.replace({ query: { ...router.query, searchTitle: search } });
    } else {
      const queryParams = router.query || {};
      delete queryParams.searchTitle;

      router.replace({ query: queryParams });
    }
  };

  return (
    <>
      <FlexContainer style={{ justifyContent: 'space-between', width: '100%' }}>
        <div style={{ display: 'flex', gap: 10 }}>
          <div style={{ width: 220 }}>
            <Search
              onSearch={handleSearch}
              placeholder={messages.commonTitle}
              size="header"
            />
          </div>

          <Filters
            customFilters={useCompletionHistoryCustomFilters()}
            filterId="profile-completions"
            filters={{}}
          />
        </div>

        <DateRangeSelector
          size="header"
          includeAllTimeOption={true}
          updateData={handleDateRangeChange}
        />
      </FlexContainer>

      <FiltersActive filterId="profile-completions" />
    </>
  );
};

export default ProfileCompletionsSubheaderFilters;
